export enum OrganizationMemberStatusType {
	ACTIVE = 'ACTIVE',
	REVOKED = 'REVOKED',
	PENDING = 'PENDING',
	SUSPENDED = 'SUSPENDED',
}

export enum OrganizationMemberType {
	ORGANIZATION_MEMBER = 'ORGANIZATION_MEMBER',
	GUEST = 'GUEST',
	TEAM = 'TEAM',
}

// intentionally hard code as we have no way to tell the role is guest or owner other than checking the name
export const GUEST_ROLE = 'GUEST';
export const OWNER_ROLE = 'OWNER';
